import { Button, TextField } from "@mui/material";
import { useState } from "react";

import { useDebouncedEffect } from "../../../../hooks/useDebounceEffect";
import axios from "../../../api/axios";
import ApiRequestErrorHandler from "../../../global/ApiRequestErrorHandler";
import ResponseModal from "../../../global/ResponseModal";

export default function PasswordCreate({ userResponse, setCookies, token }) {
  const [newPass, setNewPass] = useState("");
  const [newPassCheck, setNewPassCheck] = useState("");
  const [passMatch, setPassMatch] = useState("empty");
  const [responseModal, setResponseModal] = useState(false);
  const [responseBreakdown, setResponseBreakdown] = useState("");
  const [isError, setIsError] = useState(false);

  const resetPass = () => {
    const resetData = {
      new_password_1: newPass,
      new_password_2: newPassCheck,
    };

    axios
      .patch(`/api/users/${userResponse.pk}/set_password/`, resetData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then(() => {
        setResponseModal(true);
        setResponseBreakdown("Password has been updated");
        setIsError(false);
      })
      .catch((error) => {
        const res = error.response.data;
        const errArr = ApiRequestErrorHandler(res);
        setIsError(true);
        setResponseModal(true);
        setResponseBreakdown(errArr);
      });
  };

  const checkPass = () => {
    if (!newPass && !newPassCheck) {
      setPassMatch("empty");
    } else if (newPass !== newPassCheck && newPass.length < 8) {
      setPassMatch(false);
    } else if (newPass === newPassCheck && newPass.length >= 8) {
      setPassMatch(true);
    }
  };

  useDebouncedEffect(
    () => {
      checkPass();
    },
    [newPass, newPassCheck],
    250
  );

  const closeResModal = () => {
    setResponseModal(false);
    setResponseBreakdown("");
    if (!isError) {
      setCookies(userResponse, token);
    } else {
      setIsError(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-fit w-[95%] rounded-xl border bg-gray-200 pt-10 shadow-lg sm:mx-0 sm:w-1/2">
        <div className="mx-auto w-3/4 py-4">
          <>
            <div className="mx-auto w-3/4">
              <h3 className="text-center text-xl font-bold">Create New Password</h3>
              <TextField
                style={{ width: "100%", margin: "1rem 0" }}
                className="my-4 w-full text-center"
                placeholder="New Password"
                type="password"
                autoComplete="off"
                label="Password"
                value={newPass}
                InputLabelProps={{ shrink: true }}
                onChange={(event) => setNewPass(event.target.value)}
                error={!passMatch ? true : passMatch === "empty" ? false : false}
              />
              <TextField
                style={{ width: "100%", margin: "1rem 0" }}
                className="my-4 w-full text-center"
                placeholder="Confirm New Password"
                type="password"
                autoComplete="off"
                label="Confirm Password"
                value={newPassCheck}
                InputLabelProps={{ shrink: true }}
                onChange={(event) => setNewPassCheck(event.target.value)}
                error={!passMatch ? true : passMatch === "empty" ? false : false}
                helperText={passMatch ? "" : "Passwords need to match"}
              />
              <Button
                className="mx-auto block"
                variant="outlined"
                onClick={resetPass}
                disabled={!passMatch ? true : passMatch === "empty" ? true : false}
              >
                Update
              </Button>
            </div>
          </>
        </div>
        {responseModal && (isError || responseBreakdown) && (
          <ResponseModal
            title={`${isError ? "Failed" : "Successful"}`}
            isError={isError}
            description={isError ? "" : responseBreakdown}
            openBool={responseModal}
            setOpenBool={setResponseModal}
            errorMessage={responseBreakdown}
            handleCloseFunc={closeResModal}
          />
        )}
      </div>
    </div>
  );
}
